<template>
  <v-container class="container" fill-height fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex md12 sm12 lg12 xs12>
        <!-- <Loading v-show="showLoading" /> -->
        <template>
          <v-card id="meteo" class="card ">
            <v-toolbar
              color="light-green lighten-2"
              dark
              style="position: sticky; top: 0; z-index: 1; background-color:#81D4FA; padding-left:5%; margin-bottom:-8px;"
            >
              <v-toolbar-title
                center
                style="color: white !important; text-align: center !important;"
                class="justify-center"
              >
                <h4 class="text-xs-center">
                  <v-icon class="icon">mdi-cloud</v-icon>CLIMA DE HOY
                </h4>
              </v-toolbar-title>
            </v-toolbar>
            <v-layout v-if="showTable">
              <br>
              <v-flex>
                <h4 class="text-xs-center">Temp. Max: {{ tmax[0] }}℃</h4>
                <h4 class="text-xs-center">Temp. Min: {{ tmin[0] }}℃</h4>
              </v-flex>
              <v-flex>
                <h4 class="text-xs-center">
                  Velocidad Viento: {{ windSpeed[0] }}km/h
                </h4>
                <h4 class="text-xs-center">
                  Dirección Viento: {{ windDeg[0] }}º
                </h4>
              </v-flex>
            </v-layout>
          </v-card>
          <br />
          <br />

          <v-card >
            <v-toolbar
              color="light-green lighten-2"
              dark
              style="position: sticky; top: 0; z-index: 1; background-color:#81D4FA; padding-left:5%; margin-bottom:-8px;"
            >
              <v-toolbar-title
                center
                style="color: white !important; text-align: center !important;"
                class="justify-center"
              >
                <h4 class="text-xs-center">
                  <v-icon class="icon">mdi-chart-pie</v-icon>ESTADÍSTICAS PLAGAS Y ENFERMEDADES 
                </h4>
              </v-toolbar-title>
            </v-toolbar>
            <div class="graphs">
            <v-layout row wrap>
              <v-flex md4 sm12 lg4>
                <div id="pieChartA" style="width:100%;  height:300px;"></div>
              </v-flex >
              <v-flex md4 sm12 lg4>
                <div id="pieChartB" style="width:100%;  height:300px;"></div>
              </v-flex >
              <v-flex md4 sm12 lg4>
                <div id="pieChartC" style="width:100%;  height:300px;"></div>
              </v-flex>
            </v-layout>
            </div>
          </v-card>
          <br>

          <v-layout row wrap>
            <v-flex md4 sm12 lg4>
              <v-card class="card">
                <v-toolbar
                  color="light-green lighten-2"
                  dark
                  style="position: sticky; top: 0; z-index: 1; background-color:#81D4FA; padding-left:5%; margin-bottom:-8px;"
                >
                  <v-toolbar-title
                    center
                    style="color: white !important; text-align: center !important;"
                    class="justify-center"
                  >
                    <h4 class="text-xs-center">
                      <v-icon class="icon">mdi-book-open</v-icon>REPORTE DEL MES
                    </h4>
                  </v-toolbar-title>
                </v-toolbar>

                <div class="report-table">
                  <br />
                  <v-data-table
                    :headers="headers"
                    :items="findingsMonth"
                    hide-actions
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>
                        <p>
                          {{ props.item.plagueName }}
                        </p>
                      </td>
                      <td>
                        <p>
                          {{ props.item.total }}
                        </p>
                      </td>
                    </template>
                  </v-data-table>
                </div>
              </v-card>
            </v-flex>
            <v-flex md4 sm12 lg4>
              <v-card class="card">
                <v-toolbar
                  color="light-green lighten-2"
                  dark
                  style="position: sticky; top: 0; z-index: 1; background-color:#81D4FA; padding-left:5%; margin-bottom:-8px;"
                >
                  <v-toolbar-title
                    center
                    style="color: white !important; text-align: center !important;"
                    class="justify-center"
                  >
                    <h4 class="text-xs-center">
                      <v-icon class="icon">mdi-book-open</v-icon>REPORTE DE LA SEMANA
                    </h4>
                  </v-toolbar-title>
                </v-toolbar>

                <div class="report-table">
                  <br />
                  <v-data-table
                    :headers="headers"
                    :items="findingsWeek"
                    hide-actions
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>
                        <p>
                          {{ props.item.plagueName }}
                        </p>
                      </td>
                      <td>
                        <p>
                          {{ props.item.total }}
                        </p>
                      </td>
                    </template>
                  </v-data-table>
                </div>
              </v-card>
            </v-flex>
            <v-flex md4 sm12 lg4>
              <v-card class="card">
                <v-toolbar
                  color="light-green lighten-2"
                  dark
                  style="position: sticky; top: 0; z-index: 1; background-color:#81D4FA; padding-left:5%; margin-bottom:-8px;"
                >
                  <v-toolbar-title
                    center
                    style="color: white !important; text-align: center !important;"
                    class="justify-center"
                  >
                    <h4 class="text-xs-center">
                      <v-icon class="icon">mdi-book-open</v-icon>REPORTE DEL DÍA
                    </h4>
                  </v-toolbar-title>
                </v-toolbar>

                <div class="report-table">
                  <br />
                  <v-data-table
                    :headers="headers"
                    :items="findingsDaily"
                    hide-actions
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>
                        <p>
                          {{ props.item.plagueName }}
                        </p>
                      </td>
                      <td>
                        <p>
                          {{ props.item.total }}
                        </p>
                      </td>
                    </template>
                  </v-data-table>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
          <br />

          <v-card class="map-card">
            <v-toolbar
              color="light-green lighten-2"
              dark
              style="position: sticky; top: 0; z-index: 1; background-color:#81D4FA; padding-left:5%; margin-bottom:-8px;"
            >
              <v-toolbar-title
                center
                style="color: white !important; text-align: center !important;"
                class="justify-center"
              >
                <h4 class="text-xs-center">
                  <v-icon class="icon">mdi-book-open</v-icon>MAPA
                </h4>
              </v-toolbar-title>
            </v-toolbar>
            <br />
            <br />
            <table class="map">

              <tbody id="panzoom-element" :options="{minZoom: 0.5, maxZoom: 5}">
                <!-- CREATES PARCEL OR AGROUNIT -->
                <tr
                  v-for="(parcel, index) in parcels"
                  :key="parcel.id"
                  class="row-map"
                >
                  <h3 class="text-xs-left unit">{{ parcel.name }}</h3>

                  <!-- CREATES TUNNELS -->
                  <v-layout class="land">
                    <div
                      v-for="(item, ind) in groupParcels[index]"
                      :key="item.message"
                      class="tunnel"
                    >
                      <!-- TUNEL HEADER  -->

                      <h4 class="text-xs-center">
                        <v-icon class="">mdi-garage-open</v-icon>{{ item.name}}
                      </h4>


                      <!-- ADELANTE -->
                      <v-tooltip bottom>
                        <template class="labels" v-slot:activator="{ on }">
                          <div
                            class="text-xs-center box"
                            v-for="name in front['ALTO'][index][ind]"
                            :key="name"
                          >
                            <p class="label blink_me" v-if="name['Pulgon'] > 1">
                              🦗 PULGON A.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca blanca'] > 3"
                            >
                              🦟 MOSCA BLANCA A.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Araña roja'] > 3"
                            >
                              🐜 ARAÑA ROJA A.
                            </p>
                            <p class="label blink_me" v-if="name['Trips'] > 3">
                              🐜 TRIPS A.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Lepidopteros'] > 1"
                            >
                              🐜 LEPID. A.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca fruta'] > 0"
                            >
                              🦟 MOSCA FRUTA A.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Roya'] > 1"
                            >
                              🐛 ROYA A.
                            </p>
                            <p class="label blink_me" v-if="name['Botrytis'] > 3">
                              🦟 BOTRYTIS A.
                            </p>
                          </div>

                          <div
                            class="text-xs-center box"
                            v-for="name in front['MEDIO'][index][ind]"
                            :key="name"
                          >
                            <p class="label blink_me" v-if="name['Pulgon'] > 3">
                              🦗 PULGON M. 
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca blanca'] > 5"
                            >
                              🦟 MOSCA BLANCA M.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Araña roja'] > 5"
                            >
                              🐜 ARAÑA ROJA M.
                            </p>
                            <p class="label blink_me" v-if="name['Trips'] > 2">
                              🐜 TRIPS M.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Lepidopteros'] > 2"
                            >
                              🐜 LEPID. M.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca fruta'] > 0"
                            >
                              🦟 MOSCA FRUTA M.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Roya'] > 2"
                            >
                              🐛 ROYA M.
                            </p>
                            <p class="label blink_me" v-if="name['Botrytis'] > 0">
                              🦟 BOTRYTIS M.
                            </p>
                          </div>
                          
                          <div
                            class="text-xs-center box"
                            v-for="name in front['BAJO'][index][ind]"
                            :key="name"
                          >
                            <p class="label blink_me" v-if="name['Pulgon'] > 5 ">
                              🦗 PULGON B.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca blanca'] > 8"
                            >
                              🦟 MOSCA BLANCA B.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Araña roja'] > 10"
                            >
                              🐜 ARAÑA ROJA B.
                            </p>
                            <p class="label blink_me" v-if="name['Trips'] > 2">
                              🐜 TRIPS B.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Lepidopteros'] > 2"
                            >
                              🐜 LEPID. B.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca fruta'] > 0"
                            >
                              🦟 MOSCA FRUTA B.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Roya'] > 2"
                            >
                              🐛 ROYA B.
                            </p>
                            <p class="label blink_me" v-if="name['Botrytis'] > 0">
                              🦟 BOTRYTIS B.
                            </p>
                          </div>
                          <div
                            v-on="on"
                            v-for="(line, i) in item.lines"
                            :key="line.id"
                            class="column"
                          >
                            <p class="bush">🌳</p>
                            <p class="bush">🌳</p>
                            <p class="bush">🌳</p>
                            <p class="bush">🌳</p>
                          </div>
                        </template>
                        <span>{{ front['ALTO'][index][ind] }}</span> 
                        <span>{{ front['MEDIO'][index][ind] }}</span> 
                        <span>{{ front['BAJO'][index][ind] }}</span> 
                      </v-tooltip>
                      <h6 class="position">
                        ADELANTE
                      </h6>



                      <!-- MEDIO -->
                      <v-tooltip bottom>
                        <template class="labels" v-slot:activator="{ on }">
                          <div
                            class="text-xs-center box"
                            v-for="name in medium['ALTO'][index][ind]"
                            :key="name"
                          >
                            <p class="label blink_me" v-if="name['Pulgon'] > 1">
                              🦗 PULGON A.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca blanca'] > 3"
                            >
                              🦟 MOSCA BLANCA A.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Araña roja'] > 3"
                            >
                              🐜 ARAÑA ROJA A.
                            </p>
                            <p class="label blink_me" v-if="name['Trips'] > 3">
                              🐜 TRIPS A.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Lepidopteros'] > 1"
                            >
                              🐜 LEPID. A.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca fruta'] > 0"
                            >
                              🦟 MOSCA FRUTA A.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Roya'] > 1"
                            >
                              🐛 ROYA A.
                            </p>
                            <p class="label blink_me" v-if="name['Botrytis'] > 3">
                              🦟 BOTRYTIS A.
                            </p>
                          </div>

                          <div
                            class="text-xs-center box"
                            v-for="name in medium['MEDIO'][index][ind]"
                            :key="name"
                          >
                            <p class="label blink_me" v-if="name['Pulgon'] > 3">
                              🦗 PULGON M. 
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca blanca'] > 5"
                            >
                              🦟 MOSCA BLANCA M.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Araña roja'] > 5"
                            >
                              🐜 ARAÑA ROJA M.
                            </p>
                            <p class="label blink_me" v-if="name['Trips'] > 2">
                              🐜 TRIPS M.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Lepidopteros'] > 2"
                            >
                              🐜 LEPID. M.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca fruta'] > 0"
                            >
                              🦟 MOSCA FRUTA M.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Roya'] > 2"
                            >
                              🐛 ROYA M.
                            </p>
                            <p class="label blink_me" v-if="name['Botrytis'] > 0">
                              🦟 BOTRYTIS M.
                            </p>
                          </div>
                          
                          <div
                            class="text-xs-center box"
                            v-for="name in medium['BAJO'][index][ind]"
                            :key="name"
                          >
                            <p class="label blink_me" v-if="name['Pulgon'] > 5 ">
                              🦗 PULGON B.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca blanca'] > 8"
                            >
                              🦟 MOSCA BLANCA B.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Araña roja'] > 10"
                            >
                              🐜 ARAÑA ROJA B.
                            </p>
                            <p class="label blink_me" v-if="name['Trips'] > 2">
                              🐜 TRIPS B.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Lepidopteros'] > 2"
                            >
                              🐜 LEPID. B.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca fruta'] > 0"
                            >
                              🦟 MOSCA FRUTA B.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Roya'] > 2"
                            >
                              🐛 ROYA B.
                            </p>
                            <p class="label blink_me" v-if="name['Botrytis'] > 0">
                              🦟 BOTRYTIS B.
                            </p>
                          </div>
                          <div
                            v-on="on"
                            v-for="(line, i) in item.lines"
                            :key="line.id"
                            class="column"
                          >
                            <p class="bush">🌳</p>
                            <p class="bush">🌳</p>
                            <p class="bush">🌳</p>
                            <p class="bush">🌳</p>
                          </div>
                        </template>
                        <span>{{ medium['ALTO'][index][ind] }}</span> 
                        <span>{{ medium['MEDIO'][index][ind] }}</span> 
                        <span>{{ medium['BAJO'][index][ind] }}</span> 
                      </v-tooltip>
                      <h6 class="position">
                        MEDIO
                      </h6>



                      <!-- ATRAS -->
                      <v-tooltip bottom>
                        <template class="labels" v-slot:activator="{ on }">
                          <div
                            class="text-xs-center box"
                            v-for="name in back['ALTO'][index][ind]"
                            :key="name"
                          >
                            <p class="label blink_me" v-if="name['Pulgon'] > 1">
                              🦗 PULGON A.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca blanca'] > 3"
                            >
                              🦟 MOSCA BLANCA A.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Araña roja'] > 3"
                            >
                              🐜 ARAÑA ROJA A.
                            </p>
                            <p class="label blink_me" v-if="name['Trips'] > 3">
                              🐜 TRIPS A.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Lepidopteros'] > 1"
                            >
                              🐜 LEPID. A.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca fruta'] > 0"
                            >
                              🦟 MOSCA FRUTA A.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Roya'] > 1"
                            >
                              🐛 ROYA A.
                            </p>
                            <p class="label blink_me" v-if="name['Botrytis'] > 3">
                              🦟 BOTRYTIS A.
                            </p>
                          </div>

                          <div
                            class="text-xs-center box"
                            v-for="name in back['MEDIO'][index][ind]"
                            :key="name"
                          >
                            <p class="label blink_me" v-if="name['Pulgon'] > 3">
                              🦗 PULGON M. 
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca blanca'] > 5"
                            >
                              🦟 MOSCA BLANCA M.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Araña roja'] > 5"
                            >
                              🐜 ARAÑA ROJA M.
                            </p>
                            <p class="label blink_me" v-if="name['Trips'] > 2">
                              🐜 TRIPS M.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Lepidopteros'] > 2"
                            >
                              🐜 LEPID. M.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca fruta'] > 0"
                            >
                              🦟 MOSCA FRUTA M.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Roya'] > 2"
                            >
                              🐛 ROYA M.
                            </p>
                            <p class="label blink_me" v-if="name['Botrytis'] > 0">
                              🦟 BOTRYTIS M.
                            </p>
                          </div>
                          
                          <div
                            class="text-xs-center box"
                            v-for="name in back['BAJO'][index][ind]"
                            :key="name"
                          >
                            <p class="label blink_me" v-if="name['Pulgon'] > 5 ">
                              🦗 PULGON B.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca blanca'] > 8"
                            >
                              🦟 MOSCA BLANCA B.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Araña roja'] > 10"
                            >
                              🐜 ARAÑA ROJA B.
                            </p>
                            <p class="label blink_me" v-if="name['Trips'] > 2">
                              🐜 TRIPS B.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Lepidopteros'] > 2"
                            >
                              🐜 LEPID. B.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Mosca fruta'] > 0"
                            >
                              🦟 MOSCA FRUTA B.
                            </p>
                            <p
                              class="label blink_me"
                              v-if="name['Roya'] > 2"
                            >
                              🐛 ROYA B.
                            </p>
                            <p class="label blink_me" v-if="name['Botrytis'] > 0">
                              🦟 BOTRYTIS B.
                            </p>
                          </div>
                          <div
                            v-on="on"
                            v-for="(line, i) in item.lines"
                            :key="line.id"
                            class="column"
                          >
                            <p class="bush">🌳</p>
                            <p class="bush">🌳</p>
                            <p class="bush">🌳</p>
                            <p class="bush">🌳</p>
                          </div>
                        </template>
                        <span>{{ back['ALTO'][index][ind] }}</span> 
                        <span>{{ back['MEDIO'][index][ind] }}</span> 
                        <span>{{ back['BAJO'][index][ind] }}</span> 
                      </v-tooltip>
                      <h6 class="position">
                        ATRAS
                      </h6>

                    </div>
                  </v-layout>
                </tr>
              </tbody>
            </table>
            <br>
            <div class="leyend">
              <ul>
                <li>
                  A - ALTO
                </li>
                <li>
                  M - MEDIO
                </li>
                <li>
                  B - BAJO
                </li>
              </ul>
            </div>

            <br />
          </v-card>
        </template>
        <br />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// const Loading = () => import("../components/resources/Loading.vue");
import Panzoom from 'panzoom'
import axiosApi from "../axios-api";
import moment from "moment-timezone";

import { mapMutations } from "vuex";

export default {
  components: {},
  data() {
    return {
      options: {type: Object, default: () => {}},
      ready: false,
      geojson: [],
      forecastReadyDaily: false,
      forecastReadyWeekly: false,
      forecast: [],
      weatherArray: [],
      date: [],
      humidityArray: [],
      tmax: [],
      tmin: [],
      weatherIconArray: [],
      windSpeed: [],
      windDeg: [],
      rain: [],
      showTable: false,
      forecastHora: [],
      headers: [
        {
          text: "Plagas",
          align: "left",
          sortable: true,
          value: "name",
        },
        { text: "Individuos", sortable: true, value: "individuals" },
      ],
      startus: ['ALTO', 'MEDIO', 'BAJO'],
      parcels: [],
      findingsDaily: [],
      findingsWeek: [],
      findingsMonth: [],
      groupParcels: [],
      tunnels: [],
      daily: [],
      zones: [],
      week: null,

      adelante: [],
      blocks: [
        'ADELANTE',
        'MEDIO',
        'ATRAS'
      ],
      front: {
        'ALTO': [],
        'MEDIO': [],
        'BAJO': [],
      },

      medio: [],
      medium: {
        'ALTO': [],
        'MEDIO': [],
        'BAJO': [],
      },

      atras: [],
      back: {
        'ALTO': [],
        'MEDIO': [],
        'BAJO': [],
      },
    };
  },
  computed: {
    count() {
      return this.$store.state.subProject;
    },
  },
  watch: {
    count() {
      this.new();
    },
  },
  created: async function() {
    let payload = {
      location: this.$store.state.subProject,
      agroUnitId: this.agroUnitId,
      agroUnitIds: this.$store.state.agroUnitsIds,
      dateDay: new Date(new Date(new Date()).setHours(0)),
      dateMonth: new Date(
        new Date(new Date()).setMonth(new Date(new Date()).getMonth(), 0)
      ),
      dateWeek: new Date(
        new Date(new Date()).setMonth(new Date(new Date()).getMonth(), 0)
      ),
      date2Day: new Date(new Date(new Date()).setHours(23)),
      date2Month: new Date(
        new Date(new Date()).setMonth(new Date(new Date()).getMonth(), 30)
      ),
      date2Week: new Date(
        new Date(new Date()).setMonth(new Date(new Date()).getMonth(), 30)
      ),
    };

    this.new();

    this.findingsMonth = await this.$axios
      .get(
        `/api/findPlagues/${payload.location}/${payload.dateMonth}/${payload.date2Month}`
      )
      .then((data) => {
        return data.data;
      });

      console.log("Month", this.findingsMonth)

    this.findingsWeek = await this.$axios
      .get(
        `/api/findPlagues/${payload.location}/${payload.dateMonth}/${payload.date2Month}`
      )
      .then((data) => {
        return data.data;
      });

    this.findingsDaily = await this.$axios
      .get(
        `/api/findPlagues/${payload.location}/${payload.dateDay}/${payload.date2Day}`
      )
      .then((data) => {
        return data.data;
      });

    this.parcels = await this.$axios
      .get(
        `/api/getParcels/${payload.location}/${payload.dateMonth}/${payload.date2Month}`
      )
      .then((data) => {
        console.log("PARCEL", data.data);
        return data.data;
      });

    this.getReportes();
    this.getWeekNumber(new Date());
  },
  mounted() {
    this.panzoom = Panzoom(document.getElementById('panzoom-element'), {
        maxScale: 1
    })
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    getWeekNumber(d) {
      // Copy date so don't modify original
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      // Set to nearest Thursday: current date + 4 - current day number
      // Make Sunday's day number 7
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
      // Get first day of year
      let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      // Calculate full weeks to nearest Thursday
      let weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
      // Return array of year and week number

      this.week = weekNo;
    },
    refresh() {
      this.ready = true
    },
    new: async function() {
      let id = this.$store.state.subProjectsArr.find(
        (x) => x.name === this.$store.state.subProject
      ).id;
      this.geojson = await axiosApi.get(
        `/agrounit-geofence/get-all-by-subproject/${id}`
      );
      this.geojson = this.geojson.data;
      this.center = this.geojson[0].location.coordinates[0];
      this.center = this.center[0];
      this.getForecast();
    },
    getReportes: async function() {
      let payload0 = {
        block: "ADELANTE",
        stratus: "",
        location: this.$store.state.subProject,
        agroUnitId: this.agroUnitId,
        agroUnitIds: this.$store.state.agroUnitsIds,
        date: new Date(new Date().setHours(0)).toISOString().toString(),
        date2: new Date(new Date().setHours(23)).toISOString().toString(),
      };
      Array.prototype.groupBy = function(funcProp) {
        return this.reduce(function(acc, val) {
          (acc[funcProp(val)] = acc[funcProp(val)] || []).push(val);
          return acc;
        }, []);
      };

      await this.$axios.post(`/api/getTunels/`, payload0).then((data) => {
        this.tunnels = data.data;
        let group = this.tunnels.groupBy((c) => c.parcelId);
        this.groupParcels = group.filter(function(el) {
          return el != null;
        });
      });

      const fetchData = async (stratus) => {

      let payload = {
        block: "ADELANTE",
        stratus: stratus,
        location: this.$store.state.subProject,
        agroUnitId: this.agroUnitId,
        agroUnitIds: this.$store.state.agroUnitsIds,
        date: new Date(new Date().setHours(0)).toISOString().toString(),
        date2: new Date(new Date().setHours(23)).toISOString().toString(),
      };

      let payload2 = {
        block: "MEDIO",
        stratus: stratus,
        location: this.$store.state.subProject,
        agroUnitId: this.agroUnitId,
        agroUnitIds: this.$store.state.agroUnitsIds,
        date: new Date(new Date().setHours(0)).toISOString().toString(),
        date2: new Date(new Date().setHours(23)).toISOString().toString(),
      };

      let payload3 = {
        block: "ATRAS",
        stratus: stratus,
        location: this.$store.state.subProject,
        agroUnitId: this.agroUnitId,
        agroUnitIds: this.$store.state.agroUnitsIds,
        date: new Date(new Date().setHours(0)).toISOString().toString(),
        date2: new Date(new Date().setHours(23)).toISOString().toString(),
      };

      this.adelante = await this.$axios
        .post(`/api/getTunelsDaily/`, payload)
        .then((data) => {
          let tunnels = data.data;
          console.log("QUERY 1", data.data);
          let group = tunnels.groupBy((c) => c.parcelId);
          let filteredGroup = group.filter(function(el) {
            return el != null;
          });
            filteredGroup.forEach((parcel, ind) => {
            let emptyArr = [];
            console.log("parcel", parcel);
            parcel.forEach((tunel, i) => {
              let counter = tunel.PlagueReports.reduce(function(acc, report) {
                let counts = report.Findings.reduce((p, c) => {
                  let plagueName = c.plagueName;
                  if (!p.hasOwnProperty(plagueName)) {
                    p[plagueName] = 0;
                  }
                  p[plagueName] += c.individuals;
                  return p;
                }, {});
                // console.log("zzz", counts);
                acc.push(counts);
                return acc;
              }, []);
              emptyArr.push(counter);
            });
            this.front[`${stratus}`].push(emptyArr);
          });
        });
  

        await this.$axios
          .post(`/api/getTunelsDaily/`, payload2)
          .then((data) => {
            let tunnels = data.data;
            let group = tunnels.groupBy((c) => c.parcelId);
            let filteredGroup = group.filter(function(el) {
              return el != null;
            });
          filteredGroup.forEach((parcel) => {
            let emptyArr = [];
            console.log("parcel", parcel);
            parcel.forEach((tunel) => {
              let counter = tunel.PlagueReports.reduce(function(acc, report) {
                let counts = report.Findings.reduce((p, c) => {
                  let plagueName = c.plagueName;
                  if (!p.hasOwnProperty(plagueName)) {
                    p[plagueName] = 0;
                  }
                  p[plagueName] += c.individuals;
                  return p;
                }, {});
                // console.log("zzz", counts);
                acc.push(counts);
                return acc;
              }, []);
              emptyArr.push(counter);
            });
            this.medium[`${stratus}`].push(emptyArr);
          });
        });
  
        this.atras = await this.$axios
          .post(`/api/getTunelsDaily/`, payload3)
          .then((data) => {
            let tunnels = data.data;
            let group = tunnels.groupBy((c) => c.parcelId);
            let filteredGroup = group.filter(function(el) {
              return el != null;
            });
            filteredGroup.forEach((parcel) => {
              let emptyArr = [];
              parcel.forEach((tunel) => {
                let counter = tunel.PlagueReports.reduce(function(acc, report) {
                  let counts = report.Findings.reduce((p, c) => {
                    let plagueName = c.plagueName;
                    if (!p.hasOwnProperty(plagueName)) {
                      p[plagueName] = 0;
                    }
                    p[plagueName] += c.individuals;
                    return p;
                  }, {});
                  acc.push(counts);
                  return acc;
                }, []);
                emptyArr.push(counter);
              });
              this.back[`${stratus}`].push(emptyArr);
            });
          });
      }
      fetchData('ALTO')
      fetchData('MEDIO')
      fetchData('BAJO')


      this.findingsMonth.forEach(finding => {
        finding.name = finding.plagueName
        finding.y = finding.total
      })

      this.chart = this.$Highcharts.chart('pieChartA', {
          chart: {
              type: 'pie',
          },
          title: {
              text: `MES - ${new Date().toLocaleString('es-ES', { month: 'long' })}`
          },
          tooltip: {
              pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          accessibility: {
              point: {
                  valueSuffix: '%'
              }
          },
          plotOptions: {
              pie: {
                  allowPointSelect: true,
                  cursor: 'pointer',
                  depth: 35,
                  colors: ['#03A9F4',  '#9C27B0', '#FF9800', '#8BC34A', '#673AB7'],
                  dataLabels: {
                      enabled: true,
                      format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                  }
              }
          },
          series: [{
              name: 'Plagas',
              colorByPoint: true,
              data: this.findingsMonth
          }]
      });

      this.findingsWeek.forEach(finding => {
        finding.name = finding.plagueName
        finding.y = finding.total
      })

      this.chart = this.$Highcharts.chart('pieChartB', {
          chart: {
              type: 'pie',
          },
          title: {
              text: `SEMANA - ${this.week}`
          },
          tooltip: {
              pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          accessibility: {
              point: {
                  valueSuffix: '%'
              }
          },
          plotOptions: {
              pie: {
                  allowPointSelect: true,
                  cursor: 'pointer',
                  depth: 35,
                  colors: ['#03A9F4',  '#9C27B0', '#FF9800', '#8BC34A', '#673AB7'],
                  dataLabels: {
                      enabled: true,
                      format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                  }
              }
          },
          series: [{
              name: 'Plagas',
              colorByPoint: true,
              data: this.findingsWeek
          }]
      });

      this.findingsDaily.forEach(finding => {
        finding.name = finding.plagueName
        finding.y = finding.total
      })

      this.chart = this.$Highcharts.chart('pieChartC', {
          chart: {
              type: 'pie',
          },
          title: {
              text: `DÍA - ${new Date().getUTCDate()}`
          },
          tooltip: {
              pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          accessibility: {
              point: {
                  valueSuffix: '%'
              }
          },
          plotOptions: {
              pie: {
                  allowPointSelect: true,
                  cursor: 'pointer',
                  depth: 35,
                  colors: ['#03A9F4',  '#9C27B0', '#FF9800', '#8BC34A', '#673AB7'],
                  dataLabels: {
                      enabled: true,
                      format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                  }
              }
          },
          series: [{
              name: 'Plagas',
              colorByPoint: true,
              data: this.findingsDaily
          }]
      });



    },
    getForecast: async function() {
      let coordinates = [...this.geojson[0].location.coordinates[0][0]];
      let lat = coordinates[0];
      let long = coordinates[1];

      this.forecast = await axiosApi
        .get(
          `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${long}&units=metric&lang=es&appid=ab5d66088e31a1c47b20b04fbf191a92`
        )
        .then((res) => {
          moment.locale("es");
          for (let i = 0; i < 7; i++) {
            this.date[i] = moment()
              .add(i, "days")
              .format("MMM Do");
            this.humidityArray[i] = res.data.daily[i].humidity;
            this.tmax[i] = res.data.daily[i].temp.max;
            this.tmin[i] = res.data.daily[i].temp.min;
            this.windDeg[i] = res.data.daily[i].wind_deg;
            this.windSpeed[i] = res.data.daily[i].wind_speed;
            this.rain[i] = res.data.daily[i].rain;
            this.weatherIconArray[i] =
              "http://openweathermap.org/img/wn/" +
              res.data.daily[i].weather["0"].icon +
              "@2x.png";
            this.weatherArray[i] = res.data.daily[i].weather["0"].description;
          }
        });
      this.showTable = true;
    },
  },
};
</script>

<style scoped>

.graphs {
  /* height: ; */
  padding: 30px;
}

.land{
  margin: 100px;
  
}

.icon {
  margin-right: 10px;
  margin-left: 10px;
}

.unit {
  font-weight: bold;
  padding-left: 2% !important; 
  margin-bottom: -0.5%;
}

.report-table {
  transform: scale(0.95);
  transform-origin: 0% 0% 0px;
  padding: 2% 2% 2% 2%;
}

.map {
  cursor: zoom-in;
  background-color: rgba(180, 50, 30, 0.04);
  border: 3px solid rgba(65, 63, 63, 0.3);
  border-radius: 10px;
  box-shadow: rgba(65, 63, 63, 0.1) 1px 6px 6px;
  display: flex;
  height: 700px;
  overflow-x: auto;
  margin-left: 3%;
  width: 95% !important;
}

.map-card {
  margin-bottom: 50px;
}

.land {
  height: 260px !important;
  padding-left: 2% !important;
  margin-top: 1% !important;
  margin-bottom: -2% !important;
  width: auto;
  transform: scale(0.5);
  transform-origin: 0% 0% 0px;
}

.tunnel {
  cursor: pointer;
  background-color: rgba(2, 165, 10, 0.06);
  margin-top: -20px !important;
  margin-right: 25px !important;
  width: 110px;
}

.box {
  position: relative;
}

.label {
  animation: blinkingText 1s infinite;
  background-color: rgba(253, 90, 45, 0.75);
  border-radius: 5px;
  border: 1px solid white;
  color: white;
  margin-top: -9px;
  margin-bottom: -8px;
}

.row-map {
  width: 1000px;
  margin-bottom: -2% !important;
}

.bush {
  color: #8bc34a;
  font-size: 14px !important;
  margin-bottom: -10px;
}

.column {
  float: left;
  width: 20px;
}

.alert {
  background-color: red;
  color: white;
  font-weight: bold;
  position: absolute;
  margin-top: 40px;
  z-index: 1;
}
.alert2 {
  background-color: red;
  color: white;
  font-weight: bold;
  position: absolute;
  margin-top: 10px;
  z-index: 1;
}

.atras {
  margin-bottom: -2px;
}

th {
  margin-left: 10px;
  padding: 10px;
}

td {
  margin-left: 10px;
  padding: 10px;
}

.blink_me {
  animation: blinker 2.5s linear infinite;
}

.leyend {
  padding-left: 5%;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
